import Vue from 'vue'
import moment from 'moment'
export default {
  namespaced: true,
  state: () => ({
    schedules: {}
  }),
  getters: {
    schedules: state => Object.values(state.schedules),
    byId: state => id => state.schedules[id],
    caseId: state => id => state.schedules[id].caseId,
    byPatient: state => patient_id => {
      const schedules = Object.values(state.schedules)
      const schedulesfiltered = schedules.filter((item) => {
        return item.patient_id === patient_id
      })
      schedulesfiltered.sort((a, b) => {
        if (a.start_time > b.start_time) {
          return -1
        }
        if (a.start_time < b.start_time) {
          return 1
        }
        return 0
      })
      return schedulesfiltered;
    },
    byService: state => (clinic_service_id) => {
      const schedules = Object.values(state.schedules)
      return schedules.filter((item) => {
        return item.clinic_service_id === clinic_service_id
      })
    },
    byDoctorAndService: state => (doctor_id, clinic_service_id) => {
      const schedules = Object.values(state.schedules)
      return schedules.filter((item) => {
        return item.assignee_id === doctor_id && item.clinic_service_id === clinic_service_id
      })
    },
    byDoctor: state => (doctor_id) => {
      const schedules = Object.values(state.schedules)
      return schedules.filter((item) => {
        return item.assignee_id === doctor_id
      })
    },
    byDate: state => date => {
      const schedules = Object.values(state.schedules)
      return schedules.filter((item) => {
        return moment(item.start_time).format('YYYY-MM-DD') === date
      })
    },
    dates: state => {
      const schedules = Object.values(state.schedules)
      const dates = Array.from(new Set(schedules.map((item) => moment(item.start_time).format('YYYY-MM-DD'))))
      dates.sort()
      dates.reverse()
      return dates
    },
    schedulesAsc: state => {
      const schedules = Object.values(state.schedules)
      schedules.sort((a, b) => {
        if (a.start_time < b.start_time) {
          return -1
        }
        if (a.start_time > b.start_time) {
          return 1
        }
        return 0
      })
      return schedules
    },
    schedulesAscNotCancelled: state => {
      const schedules = Object.values(state.schedules)
      schedules.sort((a, b) => {
        if (a.start_time < b.start_time) {
          return -1
        }
        if (a.start_time > b.start_time) {
          return 1
        }
        return 0
      })
      const ret = []
      for (const s of schedules) {
        if (s.status !== 'cancelled' && s.status !== 'completed' && moment(s.start_time).diff(moment().startOf('day')) >= 0) {
          ret.push(s)
        }
      }
      return ret
    }
  },
  mutations: {
    set(
      state,
      {
        id,
        patient_id,
        city_id,
        address,
        patient,
        clinic_service_id,
        clinic_service,
        clinic_id,
        service_id,
        assignee_id,
        assignee,
        communication_days,
        start_time,
        status,
        price,
        comment,
        interview_id,
        interview_status,
        interview_activated_by,
        patient_case_id,
        created_at,
        created_by
      }
    ) {
      if (!state.schedules[id]) {
        Vue.set(state.schedules, id, {})
      }
      Vue.set(state.schedules[id], 'id', id)
      Vue.set(state.schedules[id], 'city_id', city_id)
      Vue.set(state.schedules[id], 'address', address)
      Vue.set(state.schedules[id], 'patient_id', patient_id)
      Vue.set(state.schedules[id], 'patient', patient)
      Vue.set(state.schedules[id], 'clinic_service_id', clinic_service_id)
      Vue.set(state.schedules[id], 'clinic_service', clinic_service)
      Vue.set(state.schedules[id], 'clinic_id', clinic_id)
      Vue.set(state.schedules[id], 'service_id', service_id)
      Vue.set(state.schedules[id], 'assignee_id', assignee_id)
      Vue.set(state.schedules[id], 'assignee', assignee)
      Vue.set(state.schedules[id], 'communication_days', communication_days)
      Vue.set(state.schedules[id], 'start_time', start_time)
      Vue.set(state.schedules[id], 'status', status)
      Vue.set(state.schedules[id], 'price', price)
      Vue.set(state.schedules[id], 'comment', comment)
      Vue.set(state.schedules[id], 'interview_id', interview_id)
      Vue.set(state.schedules[id], 'interview_status', interview_status)
      Vue.set(state.schedules[id], 'interview_activated_by', interview_activated_by)
      Vue.set(state.schedules[id], 'caseId', patient_case_id)
      Vue.set(state.schedules[id], 'created_at', created_at)
      Vue.set(state.schedules[id], 'created_by', created_by)
    },
    setCaseId(state, { id, caseId }) {
      Vue.set(state.schedules[id], 'caseId', caseId)
    },
    reset(state) {
      Vue.set(state, 'schedules', {})
    }
  }
}
